const INTERP_LINEAR = 0;
const INTERP_STEP = 1;
const INTERP_CUBICSPLINE = 2;
const PATH_TRANSLATION = 0;
const PATH_ROTATION = 1;
const PATH_SCALE = 2;
const PATH_WEIGHTS = 3;
const PATH_POINTER = 4;

export { INTERP_CUBICSPLINE, INTERP_LINEAR, INTERP_STEP, PATH_POINTER, PATH_ROTATION, PATH_SCALE, PATH_TRANSLATION, PATH_WEIGHTS };
//# sourceMappingURL=types.js.map
